import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { queryClient } from '@/app/queryClient';
import { router } from '@/app/router';
import { ErrorBoundary } from '@/app/ErrorBoundary';

export function App() {
  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
        <ToastContainer
          position="top-right"
          autoClose={4000}
          newestOnTop
          closeOnClick
          pauseOnFocusLoss={false}
          theme="colored"
        />
      </QueryClientProvider>
    </ErrorBoundary>
  );
}
